import { baseApi } from '../baseApi';

export interface AcademicYear {
  id: string;
  name: string;
  startDate?: string;
  endDate?: string;
  isActive: boolean;
  logo?: string;
  classId: string;
  createdAt: string;
  updatedAt: string;
}

export interface ListParams {
  search?: string;
  sortBy?: string;
  order?: "asc" | "desc";
  page?: number;
  limit?: number;
  [key: string]: any;
}

export const academicYearApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAcademicYears: builder.query<{ success: boolean; data: AcademicYear[]; total: number; page: number; limit: number }, ListParams | void>({
      query: (params) => ({
        url: '/api/academic-years',
        params: params || undefined,
      }),
      providesTags: ['AcademicYear'],
    }),
    createAcademicYear: builder.mutation<{ success: boolean; data: AcademicYear }, Partial<AcademicYear>>({
      query: (body) => ({
        url: '/api/academic-years',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['AcademicYear', 'Dashboard'],
    }),
    updateAcademicYear: builder.mutation<{ success: boolean; data: AcademicYear }, { id: string; body: Partial<AcademicYear> }>({
      query: ({ id, body }) => ({
        url: `/api/academic-years/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['AcademicYear', 'Dashboard'],
    }),
    deleteAcademicYear: builder.mutation<{ success: boolean; message: string }, string>({
      query: (id) => ({
        url: `/api/academic-years/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AcademicYear', 'Dashboard'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAcademicYearsQuery,
  useCreateAcademicYearMutation,
  useUpdateAcademicYearMutation,
  useDeleteAcademicYearMutation,
} = academicYearApi;
